import { Button, Popover, PopoverContent, PopoverTrigger } from '@heroui/react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import React, { FC } from 'react';

import { findFormat } from '../../config/platforms';
import { useAdsGeneratorStore } from '../../model/store';
import { collectWarnings } from '../../utils/warnings';

/**
 * Lista uwag do kreacji: kontrast napisów, wyjście poza planszę i wejście
 * w strefę zasłanianą przez interfejs platformy. Kliknięcie uwagi zaznacza
 * element, którego dotyczy.
 */
export const SceneWarnings: FC = () => {
  const scene = useAdsGeneratorStore((state) => state.scene);
  const select = useAdsGeneratorStore((state) => state.select);

  if (!scene) return null;

  const warnings = collectWarnings(scene, findFormat(scene.platformId, scene.formatId));
  const errors = warnings.filter((warning) => warning.severity === 'error').length;

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Button
          size="sm"
          radius="sm"
          variant="flat"
          color={errors > 0 ? 'danger' : warnings.length > 0 ? 'warning' : 'default'}
          startContent={warnings.length > 0 ? <AlertTriangle size={16} /> : <CheckCircle2 size={16} />}
        >
          {warnings.length > 0 ? `Uwagi: ${warnings.length}` : 'Bez uwag'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="max-w-80 p-3">
        {warnings.length === 0 ? (
          <p className="text-xs text-gray-500 leading-relaxed">
            Nic nie wychodzi poza planszę, napisy mają czytelny kontrast.
            Zdjęć nie oceniamy, bo bez analizy pikseli nie wiadomo, co leży pod literami.
          </p>
        ) : (
          <ul className="flex flex-col gap-1">
            {warnings.map((warning) => (
              <li key={warning.id}>
                <button
                  type="button"
                  className="w-full rounded p-1 text-left text-xs leading-relaxed hover:bg-gray-100"
                  onClick={() => warning.elementId && select(warning.elementId)}
                >
                  <span className={warning.severity === 'error' ? 'text-danger' : 'text-warning-600'}>
                    {warning.severity === 'error' ? '● ' : '○ '}
                  </span>
                  {warning.message}
                </button>
              </li>
            ))}
          </ul>
        )}
      </PopoverContent>
    </Popover>
  );
};
